<template>
  <div>
    <el-upload
      class="upload-demo"
      :action="url"
      :headers="fileHeaders"
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      :on-success="handleUploadSuccess"
    >
      <el-button size="mini" type="primary">上传</el-button>
    </el-upload>
    <a v-if="fileUrl" :href="fileUrl" target="_blank">文件链接</a>
  </div>
</template>

<script>
import Cookies from "@/utils/cookies.js";
import { coreFileserverEndpoint } from "@/settings";
export default {
  props: {
    url: {
      type: String,
      default: coreFileserverEndpoint + "/files",
    },
    // eslint-disable-next-line vue/require-default-prop
    value: String,
  },
  data() {
    return {
      name: null,
      fileUrl: null,
      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
    };
  },
  watch: {
    value: function (val) {
      this.fileUrl = val;
      if (val !== null) {
        const ups = val.split("/");
        this.name = ups[ups.length - 1];
      }
    },
  },

  mounted() {
    // console.log("====mounted", this.value);
    this.fileUrl = this.value;
    // console.log(this.fileUrl, "++", this.fileUrl !== null);
    if (this.fileUrl !== null && this.fileUrl != undefined) {
      const ups = this.fileUrl.split("/");
      this.name = ups[ups.length - 1];
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const length = file.name.split(".").length;
      const fileSuffix = file.name.split(".")[length - 1];
      const suffixs = [
        "docx",
        "doc",
        "xlsx",
        "xls",
        "png",
        "jpg",
        "jpeg",
        "gif",
        "pdf",
        "PLT",
        "plt",
        "zip",
        "rar",
      ];
      if (!suffixs.includes(fileSuffix)) {
        this.$message.error("上传文件格式不符合要求");
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt10M && suffixs.includes(fileSuffix);
    },

    handleUploadSuccess(response, file, fileList) {
      // console.log("=====handleUploadSuccess:", file);
      this.name = file.name;
      this.fileUrl = response;
      this.$emit("input", this.fileUrl);
    },
    // handleUploadSuccess(res, file) {
    //   this.name = file.name;
    //   this.blobImageUrl = URL.createObjectURL(file.raw);
    //   this.fileUrl = res.url;
    //   this.$emit('input', this.fileUrl);
    //   this.$message.success('上传成功');
    //   this.$emit('update');
    // }
  },
};
</script>
<style>
.upload-demo {
  float: left;
  margin-right: 5px;
}
</style>>
